<script setup>

import Avatar from "primevue/avatar";
import Button from "primevue/button";
import {onMounted} from "vue";

const props = defineProps({
    canContinueToReservation: Boolean,
    theme: Object,
    forms: Object,
    roundness: Object
})
const selectedService = defineModel('selectedService')
const selectedWorker = defineModel('selectedWorker')

const form = defineModel('form');
</script>

<template>
    <section v-if="selectedService" id="service-picker" class="p-4 duration-700 transform-gpu transition-all h-full">
        <!-- Introductory Text -->
        <div class="mb-6">

            <!-- Vyberte službu -->
            <h2 class="text-xl font-bold text-gray-800 dark:text-gray-100 mt-4">{{ $t('widget.select_worker') }}</h2>

        </div>


            <div>

                <!-- Worker Selection -->
                <div v-if="selectedService?.workers.length">
                    <!-- Vyberte pracovníka -->
                    <div class="grid grid-cols-2 md:grid-cols-3 gap-4">
                        <div
                            v-for="worker in selectedService.workers"
                            :key="worker.id"
                            @click="selectedWorker = worker"
                            :class="['cursor-pointer border p-4 flex items-center space-x-4 transition-all', roundness, selectedWorker === worker ? `ring-2 ring-${theme.color}-500 bg-${theme.color}-100 dark:bg-neutral-800 dark:border-neutral-700` : 'bg-white hover:bg-neutral-50 dark:bg-neutral-800 dark:border-neutral-700 dark:hover:bg-neutral-700']"
                        >
                            <Avatar :label="worker.initials"></Avatar>
                            <div>
                                <p class="text-gray-800 dark:text-gray-100 font-medium">{{ worker.name }}</p>
                                <!-- Možná v budoucnu -->
                                <p v-if="false" class="text-sm opacity-50"><span class="text-red-500 mr-1">⏺</span>Vysoké zatížení</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        <div v-if="form.errors.id_reservation_workers" id="timeslot-error" class="text-red-500 !pt-2 text-sm">{{form.errors.id_reservation_workers}}</div>
    </section>
</template>

<style scoped lang="scss">

</style>
